import { resolveInsightsBarChartColor } from "../../../routes/pricing-reports/pricingChartsUtils";

export function buildLabelOriginPriceBarChart(rows = []) {
  const labels = rows.map((row) => row.countryLabel || row.country);
  const data = rows.map((row) =>
    Number.isFinite(row.avgUnitPrice) ? Number(row.avgUnitPrice.toFixed(2)) : null
  );
  const counts = rows.map((row) => row.count || 0);

  return {
    labels,
    datasets: [
      {
        label: "Avg unit price",
        data,
        counts,
        backgroundColor: resolveInsightsBarChartColor(),
      },
    ],
  };
}
